import { render, staticRenderFns } from "./ParentPropertyCard.vue?vue&type=template&id=01554146"
import script from "./ParentPropertyCard.vue?vue&type=script&lang=js"
export * from "./ParentPropertyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports